// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-hint[data-v-70ce794e] {\n  color: var(--color-text-lighter);\n  margin-left: 45px;\n  font-weight: 200;\n}\n", ""]);
// Exports
module.exports = exports;
